module.exports = __webpack_public_path__ + "static/media/Brios-Semillas-Descripcion-Mobile.38b64acc.webp";